import type { PurchaserPortalKey } from "@src/domain/entities/purchaser";
import type { IPurchaserRepository } from "@src/domain/repositories/purchaser";
import type { CreatePurchaserPortalKeyDTO } from "@src/domain/dto/purchasers";

export class CreatePurchaserPortalKeyUseCase {
  private readonly purchaserRepository: IPurchaserRepository;

  constructor(purchaserRepository: IPurchaserRepository) {
    this.purchaserRepository = purchaserRepository;
  }

  execute(params: CreatePurchaserPortalKeyDTO): Promise<PurchaserPortalKey> {
    return this.purchaserRepository.createPurchaserPortalKey(params);
  }
}
